import { RentModelLite } from '../models';

export type MobileBffGetActiveCustomerRentsResponse = {
  rows: RentModelLite[];
  total: number;
};
